<div class="min-h-screen w-full mx-auto px-4 flex flex-col" *ngIf="config">

  <div class="flex-none" id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo" class="logo-image">
  </div>

  <div
    class="grid grid-flow-row gap-4"
    [class.grid-cols-2]="config.galleryColumns == 2"
    [class.grid-cols-3]="config.galleryColumns == 3"
    [class.grid-cols-4]="config.galleryColumns == 4"
    [class.grid-cols-5]="config.galleryColumns == 5"
    [class.grid-cols-6]="config.galleryColumns == 6"
    [class.grid-cols-7]="config.galleryColumns == 7"
    [class.grid-cols-8]="config.galleryColumns == 8"
    [class.grid-cols-9]="config.galleryColumns == 9"
  >
    <ng-container *ngFor="let job of jobs">
      <div class="relative w-full" *ngIf="job && job.status == 'completed' && hasAtLeastOneOutputAsset(job)">
        <image-slider [images]="filter(job.assets)" [autoPlaySpeed]="job.interval || 3000" [aspectClass]="(config.galleryImageRatio ?? '1/1')"></image-slider>
      </div>
    </ng-container>
    <div class="relative overflow-hidden rounded-lg bg-black">
      <div
        class="min-h-full bg-contain bg-center bg-no-repeat"
        [style]="{ 'background-image': 'url(http://uploads.snapmatic.me/qr/qr.png)'}"></div>
    </div>
  </div>

  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper"></content-block>
</div>

